<template>
  <div style="scale: 0.8">
    <el-button v-if="show" size="small" type="danger" @click="summit">退出</el-button>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {unlockOrLockMenu} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      pwd: '',
    }
  },

  computed: {
    show() {
      let state = false
      let menuId = this.getQueryString('menuId')
      let menuList = JSON.parse(localStorage.getItem('menuLockList'))
      menuList.map(item => {
        if(item.children != null) {
          item.children.map(c => {
            if(c.id == menuId && c.lockState == 1) {
              state = true
            }
          })
        }else {
          if(item.id == menuId && item.lockState == 1) {
            state = true
          }
        }
      })
      return state
    }
  },

  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      let param = {}
      param['type'] = 1
      postFormData(unlockOrLockMenu, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$router.push({path: '/lock'})
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
